import React from 'react';
import PropTypes from 'prop-types';
import Break from './Break';
import Row from './Row';

export default class SummaryTotals extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    style: PropTypes.object
  };

  static Break = Break;
  static Row = Row;

  render() {
    const { children, style, ...rest } = this.props;
    return (
      <table style={Object.assign({ textAlign: 'right' }, style)} {...rest}>
        <tbody>
          {children}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Elements/SummaryTotals/SummaryTotals.js